/* eslint-disable @typescript-eslint/no-explicit-any */
import { IRequestNsuReceiptResponse } from "@/@types/email";
import { Tags } from "@/enum/tags";
import { apiSlice } from "./http";

export const fileInformations = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    sendEmailRequestEvidence: builder.mutation<
      void,
      { conciliation_id: string; store_code: string }
    >({
      query: ({ conciliation_id, store_code }) => {
        const params = new URLSearchParams({
          conciliation_id: conciliation_id.toString(),
          store_code: store_code.toString(),
        });

        return {
          url: `/email/request-evidence?${params.toString()}`,
          method: "POST",
        };
      },
      invalidatesTags: [Tags.EMAIL_REPORT, Tags.DIVERGENCE, Tags.STORE_CONCILIATION],
    }),
    publicSendEmailFinalizeEvidence: builder.mutation<
      void,
      { conciliation_id: string; store_code: string; solicitation_id: string }
    >({
      query: ({ conciliation_id, store_code, solicitation_id }) => {
        const params = new URLSearchParams({
          conciliation_id: conciliation_id.toString(),
          store_code: store_code,
          solicitation_id: solicitation_id,
        });

        return {
          url: `/public/email/finalize-evidence?${params.toString()}`,
          method: "POST",
        };
      },
      invalidatesTags: [Tags.EMAIL_REPORT, Tags.DIVERGENCE],
    }),
    sendEmailRequestNsuEvidence: builder.mutation<
      void,
      { conciliation_id: string; store_code: string }
    >({
      query: ({ conciliation_id, store_code }) => {
        const params = new URLSearchParams({
          conciliation_id: conciliation_id.toString(),
          store_code: store_code.toString(),
        });

        return {
          url: `/email/request-nsu?${params.toString()}`,
          method: "POST",
        };
      },
      invalidatesTags: [Tags.NSU, Tags.EMAIL_REPORT],
    }),
    sendEmailRequestNsuReceipt: builder.mutation<
      IRequestNsuReceiptResponse,
      { conciliation_id: string; store_code: string }
    >({
      query: ({ conciliation_id, store_code }) => {
        const params = new URLSearchParams({
          conciliation_id: conciliation_id.toString(),
          store_code: store_code.toString(),
        });

        return {
          url: `/email/request-nsu-receipt?${params.toString()}`,
          method: "POST",
        };
      },
      invalidatesTags: [Tags.NSU, Tags.EMAIL_REPORT],
    }),
    sendEmailFinalizeEvidence: builder.mutation<
      void,
      { conciliation_id: string; store_code: string; solicitation_id: string }
    >({
      query: ({ conciliation_id, store_code, solicitation_id }) => {
        const params = new URLSearchParams({
          conciliation_id: conciliation_id.toString(),
          store_code: store_code,
          solicitation_id: solicitation_id,
        });

        return {
          url: `/email/finalize-evidence?${params.toString()}`,
          method: "POST",
        };
      },
    }),
    sendEmailFinalizeNsuEvidence: builder.mutation<
      void,
      { conciliation_id: string; store_code: string; solicitation_id: string }
    >({
      query: ({ conciliation_id, store_code, solicitation_id }) => {
        const params = new URLSearchParams({
          conciliation_id: conciliation_id,
          store_code: store_code,
          solicitation_id: solicitation_id,
        });

        return {
          url: `/email/finalize-nsu?${params}`,
          method: "POST",
        };
      },
      invalidatesTags: [Tags.EMAIL_REPORT, Tags.NSU],
    }),
    publicSendEmailFinalizeNsuEvidence: builder.mutation<
      void,
      { conciliation_id: string; store_code: string; solicitation_id: string }
    >({
      query: ({ conciliation_id, store_code, solicitation_id }) => {
        const params = new URLSearchParams({
          conciliation_id: conciliation_id,
          store_code: store_code,
          solicitation_id: solicitation_id,
        });

        return {
          url: `/public/email/finalize-nsu?${params}`,
          method: "POST",
        };
      },
      invalidatesTags: [Tags.EMAIL_REPORT, Tags.NSU],
    }),
  }),
  overrideExisting: true,
});

export const {
  useSendEmailRequestEvidenceMutation,
  useSendEmailRequestNsuEvidenceMutation,
  useSendEmailRequestNsuReceiptMutation,
  useSendEmailFinalizeEvidenceMutation,
  usePublicSendEmailFinalizeEvidenceMutation,
  usePublicSendEmailFinalizeNsuEvidenceMutation,
  useSendEmailFinalizeNsuEvidenceMutation,
} = fileInformations;

export const {
  endpoints: {
    sendEmailRequestEvidence: { select: selectSendEmailRequestEvidence },
    sendEmailRequestNsuEvidence: { select: selectSendEmailRequestNsuEvidence },
    sendEmailFinalizeEvidence: { select: selectSendEmailFinalizeEvidence },
    sendEmailFinalizeNsuEvidence: {
      select: selectSendEmailFinalizeNsuEvidence,
    },
    sendEmailRequestNsuReceipt: { select: selectSendEmailRequestNsuReceipt },
  },
} = fileInformations;
